import { supportedLanguageNames } from "./supported"
import type { Language } from "."

export const getNamedLanguageCollection = (): Language.NamedCollection => {
  return supportedLanguageNames
}
